import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import bestPracticesSelectingElementsImg from "../../../../src/collections/blog/2020/2020-12-16-functional-testing-with-cypress-in-Meshery-ui/best-practices-selecting-elements.webp";
import cypressTestRunnerImg from "../../../../src/collections/blog/2020/2020-12-16-functional-testing-with-cypress-in-Meshery-ui/cypress-test-runner.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  bestPracticesSelectingElementsImg,
  cypressTestRunnerImg,
  React
};